import {
  NOTIFICATION_DEFAULT_DELAY,
  NotificationColors,
  useNotificationContext,
} from 'application/providers/NotificationProvider';
import { ModalTypes } from 'application/providers/ModalProvider';
import AnalyticsService, { CalledFromValues, EventNameAMP, ParamNameAMP } from 'application/services/AnalyticsService';

import { WeekDaysValues } from 'domain/media/types';

import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';

import { UseInvoiceRequestControllerProps } from './types';
import { TEXTS } from './texts';

const modalDescriptionText =
  DateUtils.NOW.getDay() === (WeekDaysValues.Saturday || WeekDaysValues.Sunday)
    ? TEXTS.INVOICE_REQUEST_TOAST_WEEKEND_TEXT
    : TEXTS.INVOICE_REQUEST_TOAST_WORKDAY_TEXT;

const failToast = {
  type: NotificationColors.ERROR,
  children: TEXTS.INVOICE_REQUEST_TOAST_FAIL_TEXT,
  delay: NOTIFICATION_DEFAULT_DELAY,
};

const useInvoiceRequestController = ({
  invoiceRequestModalOkButton,
  openModal,
  paymentByInvoiceRequest,
}: UseInvoiceRequestControllerProps) => {
  const notification = useNotificationContext();

  const onPaymentByInvoiceRequest = async () => {
    try {
      const isOk = await paymentByInvoiceRequest();

      if (isOk) {
        openModal(ModalTypes.CUSTOM, {
          title: TEXTS.INVOICE_REQUEST_INFO_MODAL_TITLE,
          description: modalDescriptionText,
          actionButtons: [invoiceRequestModalOkButton],
          hideCloseButton: false,
        });
      } else {
        notification.showNotification(failToast);
      }
    } catch (e) {
      if ((e as Error).message === TEXTS.INVOICE_REQUEST_BACKEND_LIMIT_TEXT) {
        openModal(ModalTypes.CUSTOM, {
          title: TEXTS.INVOICE_REQUEST_INFO_MODAL_TITLE,
          description: modalDescriptionText,
          actionButtons: [invoiceRequestModalOkButton],
        });
      } else {
        notification.showNotification(failToast);
      }
    }

    AnalyticsService.event(EventNameAMP.REQUEST_INVOICE_PRESSED, {
      [ParamNameAMP.CALLED_FROM]: CalledFromValues.BILLING_PAGE,
    });
  };

  return {
    onPaymentByInvoiceRequest,
  };
};

export default useInvoiceRequestController;
